import React from 'react';
import { FiUsers, FiTool, FiDollarSign, FiActivity } from 'react-icons/fi';
import { FaTractor } from 'react-icons/fa';
import '../../../../assets/css/superadmin/dashboard/dashboardstatchart/StatChart.css';

const DashboardStatcard = ({ stats }) => {
  const cards = [
    {
      title: 'Total Rental Owners',
      value: stats?.totalRentalOwners ?? 0,
      icon: <FiUsers size={28} />,
    },
    {
      title: 'Total Mechanics',
      value: stats?.totalMechanics ?? 0,
      icon: <FiTool size={28} />,
    },
    {
      title: 'Active Machinery',
      value: stats?.activeMachinery ?? 0,
      icon: <FaTractor size={28} />,
    },
    {
      title: 'Active Mechanics',
      value: stats?.activeMechanics ?? 0,
      icon: <FiActivity size={28} />,
    },
    {
      title: 'Monthly Revenue',
      value: `Rs ${Number(stats?.monthlyRevenue ?? 0).toLocaleString()}`,
      change: stats?.revenueChange != null
        ? `${stats.revenueChange >= 0 ? '+' : ''}${stats.revenueChange}%`
        : null,
      icon: <FiDollarSign size={28} />,
    },
  ];

  return (
    <div className="dashboard-stats-grid">
      {cards.map((stat, index) => (
        <div key={index} className="stat-card">
          <div className="stat-content">
            <div className="stat-text">
              <p className="stat-title">{stat.title}</p>
              <h2 className="stat-value">{stat.value}</h2>
              {stat.change && <span className="stat-change">{stat.change}</span>}
            </div>
            <div className="stat-icon">{stat.icon}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStatcard;